
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experiences/[slug]",
      function () {
        return require("private-next-pages/experiences/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experiences/[slug]"])
      });
    }
  